import theme from "../theme/theme";
// import LogoHeader from './../assets/images/icons/logo-header.png';
// import LogoShort from './../assets/images/icons/logo-short.png';
import Documenticon from './../assets/images/icons/folder.png';
import ReqIcon from "./../assets/images/icons/req.png";
import NoPermission from "./../assets/images/icons/n-permission.png";

const IMAGES = {
    // Logos come from the white-label theme (src/theme/theme.js)
    LogoHeader: theme.brand.logo,
    LogoShort: theme.brand.logoSmall || theme.brand.logo,
    Documenticon: Documenticon,
    ReqIcon: ReqIcon,
    NoPermission: NoPermission,
}
export default IMAGES